import AppDataService from "./AppDataService";

const COMMON_BASE = 'AppSwitch'

export default class AppSwitchDataService {
    static async loginWithSwitchExchangeToken(data){
        return await AppDataService.post(`${COMMON_BASE}/LoginWithSwitchExchangeToken`, data);
    }
    static async getSwitchExchangeToken(source = ""){
        return await AppDataService.get(`${COMMON_BASE}/ProduceToken?source=${source}`);
    }
}